import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

// export const getOperations = (cond: string) => {
//     return axios.post(
//       GetBackendUrlForGlobalFunctions() + `operation?where=` + cond
//     );
// };
export const getOperations = (cond: string, idList?: string[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.post(
      `${GetBackendUrlForGlobalFunctions()}operation`,
      {
        where: cond,
        ids: idList
      },
      { headers }
  );
};


export const getOperationsTemplateDetail = (t_id: number) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `operation/template/detail?where=` +
      t_id
  );
};
export const EditOperations = (obj: Object | Object[], isAllowCommit?: boolean) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.put(
      GetBackendUrlForGlobalFunctions() + `gant/op/edit`,
      obj,
      {
        headers,
        params: {
          allowCommit: isAllowCommit,
        },
      }
  );
};
export const AddOperations = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `gant/op/add`, obj, {
    headers,
  });
};
export const AddEditOperationsByTemplate = (obj: Object[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `gant/op/edit-temp`,
    obj,
    {
      headers,
    }
  );
};
export const DeleteOperations = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `gant/op/delete`, obj, {
    headers,
  });
};
export const EditGantt = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `gant/edit`, obj, {
    headers,
  });
};

export const updateDependency = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.put(
    GetBackendUrlForGlobalFunctions() + `operation/update-dependency`,
    obj,
    {
      headers,
    }
  );
};
